
import axios from '../wmsAxios'

// 保存
export const save = (data) => {
    return axios({
        url: '/tblShippingLabelDetail/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tblShippingLabelDetail/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tblShippingLabelDetail/findPage',
        method: 'post',
      data
    })
}

// 获取下一个分拣箱子
export const getNextCarton = (data) => {
  return axios({
    url: '/tblShippingLabelDetail/getNextCarton',
    method: 'post',
    data
  })
}

// 退出箱子分拣
export const exitCartonPick = (data) => {
  return axios({
    url: '/tblShippingLabelDetail/exitCartonPick',
    method: 'post',
    data
  })
}

// 完成箱子分拣
export const completeCartonPick = (data) => {
  return axios({
    url: '/tblShippingLabelDetail/completeCartonPick',
    method: 'post',
    data
  })
}

// 分箱
export const splitCarton = (data) => {
  return axios({
    url: '/tblShippingLabelDetail/splitCarton',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tblShippingLabelDetail.js